import { useCallback } from 'react';

import type { SegmentEventOptions } from '@iconik-io/shared-lib/src/analytics/segment/segment_tracking';

import { segmentTrackEvent } from '../ducks/analytics_tracking/thunks';
import { useAppDispatch } from '../store/react_redux_typed';

// The hook to simplify tracking of segment events
export const useSegmentTrackEvent = () => {
  const dispatch = useAppDispatch();

  const trackSegmentEvent = useCallback(
    (
      eventName: SegmentEventOptions['eventName'],
      properties?: SegmentEventOptions['properties'],
    ) => {
      dispatch(
        segmentTrackEvent({
          eventName,
          properties: properties ?? {},
        }),
      );
    },
    [],
  );

  return {
    trackSegmentEvent,
  };
};
